import { ApiClient } from 'ApiClient';
import { Zone } from 'interfaces';

class ZoneService {
  public getAll(): Promise<Zone[]> {
    return ApiClient.get<Zone[]>('zones');
  }

  public save({ id, data }: { id?: number; data: any }) {
    if (id) {
      return ApiClient.put(`zones/${id}`, data);
    }

    return ApiClient.post('zones', data);
  }

  public delete(id: number) {
    return ApiClient.delete(`zones/${id}`);
  }
}

const singleton = new ZoneService();

export { singleton as ZoneService };
